import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class StoreSetupV2Guard implements CanActivate {
  private readonly accessKey = 'allow-store-setup-v2';
  private readonly completedKeyPrefix = 'store-setup-v2-completed';
  private readonly legacyDashboardUserEmails = new Set([
    'younksnutritioncentral@yahoo.com',
    'you123@gmail.com'
  ]);

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (this.isStoreSetupV2Completed()) {
      return this.router.parseUrl(this.getDashboardRoute());
    }

    const hasAccess = sessionStorage.getItem(this.accessKey) === '1';
    return hasAccess ? true : this.router.parseUrl('/');
  }

  private isStoreSetupV2Completed(): boolean {
    const setup = this.safeParseJson(sessionStorage.getItem('business-Info'));
    const tourCompleted = this.toBooleanFlag(setup?.isTour ?? setup?.IsTour);

    try {
      return tourCompleted || localStorage.getItem(this.getCompletedStorageKey()) === '1';
    } catch {
      return tourCompleted;
    }
  }

  private getDashboardRoute(): string {
    return '/app/dashboard-v2';
  }

  private getCompletedStorageKey(): string {
    const setup = this.safeParseJson(sessionStorage.getItem('business-Info')) || {};
    const user = this.safeParseJson(localStorage.getItem('user')) || {};
    const loginUser = this.safeParseJson(sessionStorage.getItem('login-user')) || {};

    const businessId = String(setup?.businessId ?? setup?.id ?? 'default-business');
    const userId = String(
      setup?.userID
      ?? setup?.userId
      ?? user?.userID
      ?? user?.userId
      ?? user?.id
      ?? loginUser?.UserID
      ?? loginUser?.userID
      ?? 'default-user'
    );

    return `${this.completedKeyPrefix}-${userId}-${businessId}`;
  }

  private toBooleanFlag(value: any): boolean {
    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase();
      return normalized === 'true' || normalized === '1';
    }
    return value === true || value === 1;
  }

  private safeParseJson(raw: string | null): any {
    if (!raw) {
      return null;
    }

    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
}
